<template>
<div>
	<Form :label-width="110">
		<Row :gutter="10">
			<Col span="8">
				<FormItem label="批改单号">
					<Input v-model="params.correctionNo" clearable @on-enter="search" placeholder="请输入批改单号"></Input>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="保障凭证号">
					<Input v-model="params.certificateNo" clearable @on-enter="search" placeholder="请输入保障凭证号"></Input>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="保单号">
					<Input v-model="params.policyNo" clearable @on-enter="search" placeholder="请输入保单号"></Input>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="保障期间">
					<daterange @on-change="val=>{setDateRange(val,'policy')}" placeholder="请选择保障期间" placement="bottom-end"></daterange>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="批改方式">
					<Select v-model="params.operation" placeholder="请选择批改方式" clearable >
						<Option value="ADD">新增</Option>
						<Option value="REPLACE">替换</Option>
						<Option value="REPLACED">被替换</Option>
					</Select>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="姓名">
					<Input v-model="params.insurerName" clearable @on-enter="search" placeholder="请输入姓名"></Input>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="用工地点">
					<Input v-model="params.workUnit" clearable @on-enter="search" placeholder="请输入用工地点"></Input>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="创建时间">
					<daterange @on-change="val=>{setDateRange(val,'createTime')}" placeholder="请选择创建时间" placement="bottom-end"></daterange>
				</FormItem>
			</Col>
		</Row>
		<Row :gutter="10">
			<Col span="24" class="right">
				<Button type="info" @click="search">搜索</Button>
				<Button type="primary" @click="excel">导出</Button>
			</Col>
		</Row>
	</Form>
	<i-table :columns="columns" url="/employment/person/correction.json" class="mt10" :params="params" ref="table">
	</i-table>
</div>
</template>
<script>
import ITable from '@/components/common/ITable'
import daterange from '@/components/common/daterange'
export default {
	components:{daterange,ITable},
	data () {
		return {
			params:{},
			columns:[
				{title: '批改单号',key: 'correctionNo',width:this.$columnW.XL},
				{title: '姓名',key: 'insurerName',width:this.$columnW.M},
				{title: '批改方式',key: 'operation',width:this.$columnW.L},
				{title: '身份证号码',key: 'insurerIdNumber',width:this.$columnW.XL},
				{title: '性别',key: 'insurerGender',width:this.$columnW.M},
				{title: '保障起期',key: 'policyBegin',width:this.$columnW.L},
				{title: '保障止期',key: 'policyEnd',width:this.$columnW.L},
				{title: '保费（元）',key: 'policyFee',width:this.$columnW.M,align:'right'},
				{title: '保单号',key: 'policyNo',width:this.$columnW.XL},
				{title: '保障凭证号',key: 'certificateNo',width:this.$columnW.XL},
				{title: '投保公司',key: 'insuranceCompany',width:this.$columnW.XL},
				{title: '被保险公司',key: 'insurerCompany',width:this.$columnW.XL},
				{title: '用工地点（城市）',key: 'workUnit',width:this.$columnW.XL},
				{title: '创建时间',key: 'createTime',width:this.$columnW.XL}
			],
			total:''
		}
	},
	methods: {
		search () {
			this.$refs.table.getList();
		},
		excel () {
			this.exportToExcel("/employment/person/exportCorrection",this.params);
		},
		setDateRange (val,key) {
			this.params[key+"Begin"] = val[0];
			this.params[key+"End"] = val[1];
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/flexibleEmployer/list/correctionRecord.vue